import classNames from 'classnames'

import { getQaSelector } from '../../../utils/common'
import { Skeleton } from '../../Skeleton'
import Text from '../../Text'
import {
  BirdviewState,
  DashboardTileTone,
} from '../DashboardBirdview.constants'
import { QA_NAME_DASHBOARD_BIRDVIEW_TILE } from '../DashboardBirdview.constants.qa'
import { checkIsBirdviewLoadingState } from '../DashboardBirdview.utils.sections'

import { checkHasDashboardTileDelta } from './DashboardTile.utils'
import { DashboardTileBadge } from './DashboardTileBadge'
import { DashboardTileDelta } from './DashboardTileDelta'
import { DashboardTileGrip } from './DashboardTileGrip'
import { DashboardTileValue } from './DashboardTileValue'

import * as styles from './DashboardTile.module.css'

function DashboardTile({
  Chart = null,
  Icon,
  chartProps,
  count,
  countTooltip,
  delta,
  deltaTone,
  dragHandle,
  isRefreshing,
  label,
  state = BirdviewState.Normal,
  tone = DashboardTileTone.Info,
  onClick,
}) {
  const isLoading = checkIsBirdviewLoadingState(state)

  return (
    <div
      {...getQaSelector({ value: QA_NAME_DASHBOARD_BIRDVIEW_TILE })}
      className={classNames(styles.tile, {
        [styles.interactive]: onClick,
        [styles.refreshing]: isRefreshing,
      })}
      onClick={onClick}
    >
      {dragHandle && !isLoading ? <DashboardTileGrip /> : null}
      <span className={styles.details}>
        {isLoading ? (
          <Skeleton className={styles.labelSkeleton} />
        ) : (
          <Text isSecondary className={styles.label} title={label}>
            {label}
          </Text>
        )}
        <span className={styles.value}>
          <DashboardTileValue
            count={count}
            state={state}
            tooltip={countTooltip}
          />
          {checkHasDashboardTileDelta({ delta, state }) ? (
            <DashboardTileDelta {...delta} tone={deltaTone} />
          ) : null}
        </span>
      </span>
      {Chart ? (
        <span className={styles.chart}>
          {isLoading ? (
            <Skeleton className={styles.chartSkeleton} />
          ) : (
            <Chart {...chartProps} />
          )}
        </span>
      ) : (
        <DashboardTileBadge Icon={Icon} isLoading={isLoading} tone={tone} />
      )}
    </div>
  )
}

export default DashboardTile
